<span [title]="value">{{ value }}</span>
